import { render, staticRenderFns } from "./riskAssessmentImportDialog.vue?vue&type=template&id=c54c59ec"
import script from "./riskAssessmentImportDialog.vue?vue&type=script&lang=js"
export * from "./riskAssessmentImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports